import React from "react";
import {
  faChartLine,
  faBrain,
  faBullseye,
  faClock,
  faDatabase,
  faChartBar,
  faCheckCircle,
  faRocket,
  faStar,
  faHeart,
  faBookOpen,
  faDumbbell,
  faHandshake,
  faArrowTrendUp,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const features = [
  "Record unlimited personal activities",
  "Track Done / Not Done status",
  "Capture duration and start time",
  "Organize using multiple tags",
  "Daily, Weekly & Monthly analytics",
  "Interactive Bar & Line graphs",
  "Filter by date, duration and tags",
  "Edit records anytime",
  "Private personal activity history",
  "Future AI-powered insights",
];

const benefits = [
  "Develop consistency",
  "Know where your time goes",
  "Improve productivity",
  "Build stronger habits",
  "Stay accountable",
  "Visualize long-term progress",
  "Identify behaviour patterns",
  "Improve work-life balance",
  "Maintain your personal growth journal",
  "Become your best version",
];

const ScorePlusAbout = () => {
  return (
    <div className="space-y-6">
      {/* Hero */}

      <div className="bg-zinc-900 border border-zinc-700 rounded-xl p-5 md:p-8">
        <div className="flex flex-col md:flex-row gap-6 items-center">
          <div className="text-6xl">📈</div>

          <div className="flex-1 flex-col justify-start">
            <h1 className="text-2xl md:text-4xl font-bold text-cyan-300 text-center lg:text-left ">
              ScorePlus
            </h1>

            <p className="text-gray-400 text-sm md:text-base mt-1">
              Personal, Couple's and Family Growth & Performance Analytics Engine
            </p>

            <p className="text-gray-100 text-xs md:text-sm mt-5 leading-7">
              Every day you invest your time in learning, work, health,
              relationships and personal growth. ScorePlus transforms those
              daily efforts into measurable progress using beautiful analytics,
              intelligent insights and your own private activity database.
            </p>

            <div className="flex flex-wrap gap-3 mt-6">
              <button className="w-fit px-2 py-1 rounded-lg bg-cyan-500 text-black font-semibold hover:bg-cyan-400">
                🚀 Buy Subscription
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-zinc-900 border border-zinc-700 rounded-xl p-5">
        <h2 className="text-cyan-200 text-xl font-semibold flex items-center gap-2">
          <FontAwesomeIcon icon={faBrain} />
          Executive Summary
        </h2>

        <p className="text-gray-100 text-xs md:text-sm leading-7 mt-4">
          ScorePlus is much more than a habit tracker. It's a single objective personal, couple's 
          and family single activity and / or behavioural analytics engine that records daily activities,
          measures consistency, analyses patterns and visualizes data, growth, transformation.
          Whether you are improving your fitness, relationships, studies, career, meditation or any custom activity, 
          ScorePlus helps you build a private digital history of your journey and continuously motivates you
          to become better.
        </p>
      </div>

      {/* Features */}

      <div className="bg-zinc-900 border border-zinc-700 rounded-xl p-5">
        <h2 className="text-cyan-200 text-xl font-semibold flex items-center gap-2">
          <FontAwesomeIcon icon={faRocket} />✨ Key Features
        </h2>

        <div className="grid md:grid-cols-2 gap-3 mt-5">
          {features.map((item, index) => (
            <div
              key={index}
              className="flex gap-3 items-start bg-zinc-800 rounded-lg p-3"
            >
              <FontAwesomeIcon
                icon={faCheckCircle}
                className="text-green-400 mt-1"
              />

              <p className="text-gray-100 text-xs md:text-sm">{item}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Benefits */}

      <div className="bg-zinc-900 border border-zinc-700 rounded-xl p-5">
        <h2 className="text-cyan-200 text-xl font-semibold flex items-center gap-2">
          <FontAwesomeIcon icon={faStar} />
          🌟 Benefits
        </h2>

        <div className="grid md:grid-cols-2 gap-3 mt-5">
          {benefits.map((item, index) => (
            <div
              key={index}
              className="flex gap-3 items-start bg-zinc-800 rounded-lg p-3"
            >
              <FontAwesomeIcon
                icon={faArrowTrendUp}
                className="text-cyan-400 mt-1"
              />

              <p className="text-gray-100 text-xs md:text-sm">{item}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Quick Highlights */}

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="bg-zinc-900 border border-zinc-700 rounded-xl p-5 text-center">
          <FontAwesomeIcon
            icon={faClock}
            className="text-3xl text-cyan-300 mb-3"
          />
          <p className="text-gray-100 text-xs md:text-sm">Track Time</p>
        </div>

        <div className="bg-zinc-900 border border-zinc-700 rounded-xl p-5 text-center">
          <FontAwesomeIcon
            icon={faChartBar}
            className="text-3xl text-green-400 mb-3"
          />
          <p className="text-gray-100 text-xs md:text-sm">Visual Analytics</p>
        </div>

        <div className="bg-zinc-900 border border-zinc-700 rounded-xl p-5 text-center">
          <FontAwesomeIcon
            icon={faDatabase}
            className="text-3xl text-orange-400 mb-3"
          />
          <p className="text-gray-100 text-xs md:text-sm">Private Data Bank</p>
        </div>

        <div className="bg-zinc-900 border border-zinc-700 rounded-xl p-5 text-center">
          <FontAwesomeIcon
            icon={faBullseye}
            className="text-3xl text-pink-400 mb-3"
          />
          <p className="text-gray-100 text-xs md:text-sm">Achieve Goals</p>
        </div>
      </div>
    </div>
  );
};

export default ScorePlusAbout;
